export const SERVICES_BULK_UPLOAD_TEMPLATE_URL =
  "https://cdn.eka.care/templates/services-bulk-upload-template.csv";

export const GET_INTERNET_ERROR_MESSAGE =
  "Unable to connect to the server. Please check your internet connection and try again.";
